export const environment = {
  production: false,
  apiEndPoint: 'https://d3v50vql37fees.cloudfront.net',
  imagePreviewUrl: 'https://investdev.hectorinvestment.ai',
  productVersion: '1.0-dev',
  secretKey: 'klAuHZCWBnZMkkqaA32Zd',
  cryptoSecretKey: '00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff',
  cryptoIv: '0102030405060708090a0b0c0d0e0f10'
};
